import React from 'react';
import { CloseableModal } from '../../CloseableModal';
import { ModalBody } from './ModalBody';

interface PropTypes {
  isOpen: boolean;
  applicationId: number;
  interviewStageId: number;
  onClose: () => void;
}

export function ScheduleInterviewModal(props: PropTypes) {
  return (
    <CloseableModal
      className='modal-dialog-centered'
      onClose={() => props.onClose()}
      isOpen={props.isOpen}
      style={{ width: 'auto' }}
      size='md'
      modalHeaderTag='div'
      headerClassName='p-4 bg-gray'
      contentClassName='rounded-5'
      bodyClassName='p-4'
      closeButtonClassName='me-0'
      closeDisabled={false}
      keyboard={true}
      backdrop={true}
      headerChildren={<h3 className='m-0 fs-4'>Schedule Interview</h3>}
      bodyChildren={<ModalBody {...props} />}
    />
  );
}
